'use strict'

import random from '@core/assets/js/utils/random'

const state = () => ({
    page: {},
    pagination: {
        current_page:1,
        total_items:0,
        total_pages:1
    },
    news: []
})

// getters
const getters = {
    page: (state) => {
        return state.pate
    },
    pagination: (state) => {
        return state.pagination
    },
    news: (state) => (page = state.pagination.current_page) => {
        return state.news[page - 1] ?? false
    },
    hasNews: (state) => (page) => {
        return state.news[page - 1] ?? false
    }
}

// actions
const actions = {
    async fetchPage({ commit }, {url, next_page, limit}) {
        try {
            await this.client.Get(url, {
                datafull: true,
                query: {
                    page: next_page,
                    limit: limit,
                    rnd: random()
                },
                callback: function (response) {
                    commit('setNews', {
                        current_page: response.current_page,
                        news: response.data.news
                    })
                    commit('setPagination', {
                        'current_page': response.current_page,
                        'total_items': response.total_items,
                        'total_pages': response.total_pages
                    })
                }
            });
        } catch (error) {
            throw error; // Re-throw the error to handle it in the component
        }
    }
}

// mutations
const mutations = {
    page: (state, payload) => {
        state.page = payload
    },
    currentPage: (state, payload) => {
        state.pagination.current_page = payload
    },
    setPagination (state, payload) {
        state.pagination = payload
    },
    setNews (state, {current_page, news}) {
        state.news[current_page - 1] = news
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}